import { fork, all } from 'redux-saga/effects'
import watchUpdateFleet from 'sagas/updateFleet'
import watchFleetSizeReceived from 'sagas/fleetSizeReceived'
import watchAddXmcSuccess from 'sagas/addXmc'
import watchAddExmSuccess from 'sagas/addExm'
import watchSPDuplicate from 'sagas/validateSP'
import watchApiCall from 'sagas/apiCall'
import watchGetTruckDetails from 'sagas/getTruckDetails'
import watchGetLinkedRPs from 'sagas/getLinkedRPs'
import watchBatchSupportParameterImport from 'sagas/batchImportSPs'
import watchCreateNewSP from 'sagas/createNewSP'
import watchForToastNotifications from 'sagas/notifications/toastNotification'
import watchForPersistentNotifications from 'sagas/notifications/persistentNotification'
import watchForPersistentNotificationCleanup from 'sagas/notifications/persistentNotificationCleanup'
import { watchPersistentNotifications } from 'sagas/notifications/handleNotificationsPanel'
import * as dashSagas from 'sagas/dash'
import { watchUpdateEcp, watchFetchEcps, watchEcpState } from 'sagas/ecp'
import * as featureOutputsSagas from 'sagas/feature/outputs'
import * as conditionSagas from 'sagas/feature/conditions'
import * as batchImportFeatureSagas from 'sagas/feature/batchImport'
import * as featuresSagas from 'sagas/feature/features'
import * as featureSnapshotSagas from 'sagas/feature/snapshots'
import {
  watchFetchSnapshots,
  watchCreateSnapshot,
  watchDeleteSnapshot,
  watchFetchAsBuilt,
} from 'sagas/vehicleSnapshots'
import * as featureMetadataSagas from 'sagas/feature/featureMetadata'
import * as featureInputsSagas from 'sagas/feature/inputs'
import * as watchPendingSupportParameter from 'sagas/activatePendingSP'
import watchPageForwardingActions from 'sagas/pageForwarding'
import * as truckFeatures from 'sagas/truck/features'
import * as truckAreaFeatures from 'sagas/truck/addFeatureByArea'
import watchVehicleReferenceParametersSaved from 'sagas/truck/saveReferenceParameters'
import * as featureNotesSagas from 'sagas/feature/notes'
import { watchFeatureSavedToFixTempId } from 'sagas/feature/tempIdFix'
import watchSetOutputField, {
  watchAddLogicNodeToOutput,
} from 'sagas/feature/updateOutputNode'
import watchStartParFileDownload from 'sagas/downloadParFile'
import {
  watchFeatureSaveValidation,
  watchFeatureTestValidation,
} from 'sagas/feature/validation'
import watchAddReferenceParametersWorkflow from 'sagas/addReferenceParametersWorkflow'
import watchCtpMappingWorkflow from 'sagas/ctpMappingWorkflow'
import watchSearch, { watchBusFilterSearch } from 'sagas/search'
import {
  watchResetPreCreateNewFeature,
  watchCreateNewFeature,
  watchCreateSuccess,
} from 'sagas/feature/create'
import * as featureDeleteSagas from 'sagas/feature/delete'
import {
  watchPowerTakeOffValidation,
  watchUpdateFragments,
  watchFragmentUpdateSuccess,
  watchIsEditingPtoTemplate,
} from 'sagas/powerTakeOff'
import { watchUpdateTemplateFragments } from 'sagas/applyPtoTemplate'
import { watchCreatePtoTemplate } from 'sagas/createPtoTemplate'
import {
  watchSelectedId,
  // watchChangesToNavigator
} from 'sagas/navigator'
import watchRemoveHarness from 'sagas/feature/harnesses'
import {
  analytics,
  watchFavoriteDrawerClose,
  watchUpdateUserRoles,
  watchChangeUserRole,
  watchPersistRecentlyViewed,
  watchMergeRecentlyViewedCache,
} from 'sagas/user'
import * as simulationSagas from 'sagas/feature/simulation'
import * as fastFeatureSagas from 'sagas/feature/fastFeatures'

const forkAll = (module) => Object.values(module).map((fn) => fork(fn))

export default function* root() {
  yield all([
    fork(analytics),
    fork(watchFavoriteDrawerClose),
    fork(watchUpdateUserRoles),
    fork(watchChangeUserRole),
    fork(watchPersistRecentlyViewed),
    fork(watchMergeRecentlyViewedCache),
    fork(watchSearch),
    fork(watchBusFilterSearch),
    fork(watchSetOutputField),
    fork(watchAddLogicNodeToOutput),
    fork(watchCtpMappingWorkflow),
    fork(watchAddReferenceParametersWorkflow),
    fork(watchFeatureSavedToFixTempId),
    ...forkAll(watchPendingSupportParameter),
    fork(watchPageForwardingActions),
    ...forkAll(simulationSagas),
    ...forkAll(fastFeatureSagas),
    fork(watchBatchSupportParameterImport),
    fork(watchCreateNewSP),
    fork(watchUpdateFleet),
    fork(watchFleetSizeReceived),
    fork(watchSPDuplicate),
    fork(watchApiCall),
    fork(watchGetTruckDetails),
    fork(watchGetLinkedRPs),
    fork(watchForToastNotifications),
    fork(watchForPersistentNotifications),
    fork(watchForPersistentNotificationCleanup),
    fork(watchPersistentNotifications),
    ...forkAll(dashSagas),
    fork(watchUpdateEcp),
    fork(watchFetchEcps),
    fork(watchEcpState),
    fork(watchAddXmcSuccess),
    fork(watchAddExmSuccess),
    ...forkAll(featureOutputsSagas),
    ...forkAll(conditionSagas),
    ...forkAll(featuresSagas),
    ...forkAll(featureMetadataSagas),
    ...forkAll(featureInputsSagas),
    ...forkAll(truckFeatures),
    ...forkAll(truckAreaFeatures),
    fork(watchVehicleReferenceParametersSaved),
    ...forkAll(featureSnapshotSagas),
    fork(watchFetchSnapshots),
    fork(watchCreateSnapshot),
    fork(watchDeleteSnapshot),
    fork(watchFetchAsBuilt),
    ...forkAll(featureDeleteSagas),
    ...forkAll(batchImportFeatureSagas),
    ...forkAll(featureNotesSagas),
    fork(watchFeatureTestValidation),
    fork(watchFeatureSaveValidation),
    fork(watchResetPreCreateNewFeature),
    fork(watchCreateNewFeature),
    fork(watchCreateSuccess),
    fork(watchPowerTakeOffValidation),
    fork(watchUpdateFragments),
    fork(watchUpdateTemplateFragments),
    fork(watchCreatePtoTemplate),
    fork(watchFragmentUpdateSuccess),
    fork(watchIsEditingPtoTemplate),
    fork(watchSelectedId),
    fork(watchRemoveHarness),
    fork(watchStartParFileDownload),
    // fork(watchChangesToNavigator)
  ])
}

export const delay = (ms) => new Promise((res) => setTimeout(res, ms))
